<div id="unitSync-main-wraper">
  <div class="col-12 search-ft p-0 mt-3">
    <div class="row">
      <div class="col-3">
        <div class="form-group">
          <label name="lblUnitSync" class="control-label">Unit Number</label>
          <input type="text" class="form-control" name="txtUnitSrch" maxlength="10" [(ngModel)]="txtUnitSrch"
            tabindex="1" (keydown.enter)="onKeyEnter()"/>
        </div>
      </div> 
        <div class="col-2">
            <label name="lblPRFileType" class="control-label">File Type </label>
          <select name="ddPRFileType" class="form-control" (change)="fileTypeSelectChanged($event)"
            tabindex="2">
            <option *ngFor="let fileType of filteredFileTypes" [value]="fileType.id"
            [selected]="fileType.id === selectedFileTypeId">{{fileType.name}}</option>
          </select> 
        </div>     
      <div class="col d-flex align-items-end">      
          <div class="form-group">
            <button class="btn btn-primary mr-2" name="btnUnitSyncSrch" tabindex="3" (click)="getUnitSearch()">
              Search
            </button>
            <button class="btn btn-outline-primary mr-2" name="btnUnitSyncReset" tabindex="4" (click)="onResetFilters()">
              Reset
            </button>
          </div>
          <div id="gridActions" class="ml-auto">
              <button class="btn btn-sync-primary" [disabled]="disableSync" name="btnBiPrvsnReset" tabindex="5" (click)="open(SyncUnitInfoModal)">
                <em class="fas fa-sync-alt"></em> Sync
              </button>
          </div>
        </div>
      </div>    
  </div>
  <div>
    <ag-grid-angular #agGridUnitSync class="ag-theme-material mt-2 unitSync-layout" [rowData]="filteredRowData"
      [columnDefs]="columnDefs" [gridOptions]="gridOptions" tabindex="6">
    </ag-grid-angular>
  </div>
</div>

<ng-template #SyncUnitInfoModal let-modal>  
  <div id="syncUnit" class="modal-body eloUpdateStyle">
    <div class="col-12 search-ft p-2 mt-3">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="lblInfo">Are you sure you want to sync details for the Unit: {{ txtUnitSrch }} ..?</label> 
          </div>
        </div>
      </div>
      <div class="row col-6 mx-auto d-flex justify-content-center">
        <button type="button" class="btn btn-primary mr-2 btnwidth" (click)="onUnitSync()">Yes</button>
        <button type="button" id="btnClose" class="btn btn-outline-primary mr-2 btnwidth" (click)="modal.close()">No</button>
      </div>
    </div>
  </div>  
</ng-template>